import React, { Component } from 'react';


import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
import ParkinglocationSelect from './ParkinglocationSelect';
const FormItem = Form.Item;
const { Option } = Select;

class LocationForwardSettingForm extends Component {

    state = {
        modalVisible: false,
        confirmDirty: false,
        coreParkingLocationID: null,
    }

    form = null;



    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                try {
                    if (values.forwardConfig) values.forwardConfig = JSON.parse(values.forwardConfig);
                    if (values.forwardData) values.forwardData = JSON.parse(values.forwardData);
                } catch (parseErr) {
                    return;
                }
                if (!values.scheduledForwardTime) values.scheduledForwardTime = null;
                this.props.onSuccess(this.props.form, values);
            }
        });
    }


    renderForm() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const driverType = (typeof getFieldValue('driverType') === 'undefined') ?
            this.props.initialValues && this.props.initialValues.driverType
                ? this.props.initialValues.driverType
                : undefined : getFieldValue('driverType');

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 22,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Lokalita" >
                    {getFieldDecorator('corelocationId', {
                        initialValue: this.props.initialValues && this.props.initialValues.corelocationId
                            ? this.props.initialValues.corelocationId
                            : undefined,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ coreParkingLocationId: value }); }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Popis">
                    {getFieldDecorator('description', {
                        initialValue: this.props.initialValues && this.props.initialValues.description
                            ? this.props.initialValues.description
                            : '',
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }],
                    })(
                        <Input.TextArea
                            autosize={{
                                maxRows: 7
                            }} />
                    )}
                </FormItem>

                <FormItem
                    {...formItemLayout}
                    label="Událost" >
                    {getFieldDecorator('eventListener', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }
                        ],
                        initialValue: this.props.initialValues && this.props.initialValues.eventListener
                            ? this.props.initialValues.eventListener
                            : null,
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="ForwardConfig">
                    {getFieldDecorator('forwardConfig', {
                        initialValue: this.props.initialValues && this.props.initialValues.forwardConfig
                            ? JSON.stringify(this.props.initialValues.forwardConfig, null, 2)
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }, {
                            validator: (rule, value, callback) => {
                                if (!value) return callback();
                                let parsed;
                                try { parsed = JSON.parse(value); } catch (e) { return callback('Hodnota musí být platný JSON!'); }
                                if (typeof parsed !== 'object' || Array.isArray(parsed)) return callback('ForwardConfig musí být JSON objekt!');
                                const allowed = new Set(['method', 'url', 'headers', 'queryParams']);
                                const unknown = Object.keys(parsed).filter(k => !allowed.has(k));
                                if (unknown.length) return callback(`Nepovolené vlastnosti: ${unknown.join(', ')}`);
                                if (!parsed.method) return callback('forwardConfig.method nesmí být prázdné!');
                                if (!['GET', 'POST', 'PUT'].includes(parsed.method)) return callback('forwardConfig.method musí být GET, POST nebo PUT!');
                                if (!parsed.url || typeof parsed.url !== 'string') return callback('forwardConfig.url musí být neprázdný string!');
                                callback();
                            }
                        }],
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 10 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="ForwardData">
                    {getFieldDecorator('forwardData', {
                        initialValue: this.props.initialValues && this.props.initialValues.forwardData
                            ? JSON.stringify(this.props.initialValues.forwardData, null, 2)
                            : null,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }, {
                            validator: (rule, value, callback) => {
                                if (!value) return callback();
                                let parsed;
                                try { parsed = JSON.parse(value); } catch (e) { return callback('Hodnota musí být platný JSON!'); }
                                if (typeof parsed !== 'object' || Array.isArray(parsed)) return callback('ForwardData musí být JSON objekt!');
                                callback();
                            }
                        }],
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 10 }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Čas odeslání"
                    extra="Prázdné = odeslat ihned při změně">
                    {getFieldDecorator('scheduledForwardTime', {
                        initialValue: this.props.initialValues && this.props.initialValues.scheduledForwardTime
                            ? this.props.initialValues.scheduledForwardTime
                            : null,
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            pattern: /^([01]\d|2[0-3]):[0-5]\d$/, message: 'Formát musí být HH:MM!',
                        }],
                    })(
                        <Input placeholder="HH:MM" />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Aktivní">
                    {getFieldDecorator('active', {
                        valuePropName: 'checked',
                        initialValue: this.props.initialValues && this.props.initialValues.active
                            ? this.props.initialValues.active
                            : false,
                    })(
                        <Switch
                            checkedChildren={<Icon type="check" />}
                            unCheckedChildren={<Icon type="close" />} />
                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Uložit</Button>
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={650}
                    title="Nastavení lokality"
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedLocationForwardSettingForm = Form.create()(LocationForwardSettingForm);

export default WrappedLocationForwardSettingForm;


// WEBPACK FOOTER //
// ./src/components/LocationForwardSettingForm.js